module.exports = __webpack_public_path__ + "static/media/document-week4.0ada53c9.pdf";